// extracted by mini-css-extract-plugin
module.exports = {"switchPageBtn":"switchpageitem_switchPageBtn__15a6A","xs":"switchpageitem_xs__3jpu5"};